import { defineAction } from '~/prix'
import { z } from 'zod'
import inseminatorDeleteAction from './inseminatorDelete.action.json' with { type: 'json' }
import { inseminatorObject } from '../inseminatorObject'

const inseminatorDeleteDefinition = defineAction({
  ...inseminatorDeleteAction,

  input: inseminatorObject.pick({
    id: true,
  }),
  output: inseminatorObject.pick({
    id: true,
  }),
})

export default inseminatorDeleteDefinition
